import { useState, useCallback } from 'react';
import { DotLottie } from '@lottiefiles/dotlottie-web';

export const useLottieAnimation = () => {
    const [dotLottie, setDotLottie] = useState<DotLottie | null>(null);

    const dotLottieRefCallback = useCallback((lottie: DotLottie) => {
        setDotLottie(lottie);
    }, []);

    const play = useCallback(() => {
        if (dotLottie) {
            dotLottie.play();
        }
    }, [dotLottie]);

    const pause = useCallback(() => {
        if (dotLottie) {
            dotLottie.pause();
        }
    }, [dotLottie]);

    const stop = useCallback(() => {
        if (dotLottie) {
            dotLottie.stop();
        }
    }, [dotLottie]);

    const seek = useCallback(() => {
        if (dotLottie) {
            dotLottie.setFrame(30);
        }
    }, [dotLottie]);

    return {
        play,
        stop,
        pause,
        seek,
        dotLottieRefCallback,
        dotLottie
    };
};
